export const setMessenger = (messenger, id, field, truncated, value) => {
  messenger[`${id}:${field}:truncated`] = {
    truncated,
    value: value
  }
}

export const isTruncatedMasterCell = (ref, rowHeight) =>
  ref.current?.offsetHeight > rowHeight

export const isTruncatedDetailCell = (ref, columnWidth) => {
  return (
    ref.current?.offsetWidth > columnWidth ||
    ref.current?.offsetHeight > STANDARD_COLUMN_HEIGHT
  )
}

export const detailHeaderHeightSetter = (detGridApi, tableRef) => {
  const height = detailHeaderHeightGetter(tableRef) + HEADER_STANDARD_PADDING

  detGridApi?.api.setHeaderHeight(
    height > STANDARD_COLUMN_HEIGHT ? height : STANDARD_COLUMN_HEIGHT
  )
  detGridApi?.api.resetRowHeights()
}

const detailHeaderHeightGetter = (tableRef) => {
  const columnHeaderTexts = [
    ...(tableRef.querySelectorAll('.ag-header-cell-text') ?? [])
  ]
  const clientHeights = columnHeaderTexts.map(
    (headerText) => headerText.clientHeight
  )
  const tallestHeaderTextHeight = Math.max(...clientHeights)
  return tallestHeaderTextHeight
}

export const masterHeaderHeightSetter = (api) => {
  var height = masterHeaderHeightGetter(api) + HEADER_STANDARD_PADDING

  api.setHeaderHeight(
    height > STANDARD_COLUMN_HEIGHT ? height : STANDARD_COLUMN_HEIGHT
  )
  api.resetRowHeights()
}

const masterHeaderHeightGetter = (api) => {
  var columnHeaderTexts = [
    ...document.querySelectorAll('.inputview-grid .ag-header-cell-text')
  ]
  const visibleColsLength = api.columnController.columnApi
    .getAllColumns()
    .filter((col) => col.visible).length

  const clientHeights = columnHeaderTexts
    .slice(0, visibleColsLength - 1)
    .map((headerText) => headerText.clientHeight)

  return Math.max(...clientHeights)
}

const STANDARD_COLUMN_HEIGHT = 48
const HEADER_STANDARD_PADDING = 20
